import { Head, Link } from '@inertiajs/react'

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Head title="Home" />

      <nav className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <h1 className="text-xl font-bold text-gray-900">Doqubase</h1>
            <Link
              href="/session"
              method="delete"
              as="button"
              className="rounded-md bg-gray-100 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200"
            >
              Log out
            </Link>
          </div>
        </div>
      </nav>

      <main className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900">
            Welcome to Doqubase
          </h2>
          <p className="mt-4 text-lg text-gray-600">Your collaborative documentation workspace.</p>
        </div>
      </main>
    </div>
  )
}
